import { LargeChip } from "./LargeChip";
import { LargeIconAccessory } from "./LargeAccessory";

export const SelectableChip = Object.assign(LargeChip, {
  LargeIconAccessory,
});

export type { LargeChipProps as SelectableChipProps } from "./LargeChip";
